import { Pane } from "src/components/Pane";
import { useTranslation } from "react-i18next";
import { Button, styled, Typography } from "@mui/material";
import { Polyline, PushPin, Upload } from "@mui/icons-material";
import { useState } from "react";

interface Props {
  onPrevious: () => void;
  onNext: (option: "draw" | "upload" | "pick") => void;
}

export function CasePickShapeCreation(props: Props) {
  const { onPrevious, onNext } = props;
  const [selected, setSelected] = useState<"draw" | "upload" | "pick" | null>(null);

  const { t } = useTranslation();

  return (
    <Styles>
      <Typography variant="h4" color="primary">
        {t("title.createCase")}
      </Typography>
      <Button className={`list-item ${selected === "draw" ? "active" : ""}`} onClick={() => setSelected("draw")}>
        <Polyline />
        {t("label.drawCase")}
      </Button>
      <Button className={`list-item ${selected === "upload" ? "active" : ""}`} onClick={() => setSelected("upload")}>
        <Upload />
        {t("label.uploadCase")}
      </Button>
      <Button className={`list-item ${selected === "pick" ? "active" : ""}`} onClick={() => setSelected("pick")}>
        <PushPin />
        Pick a case
      </Button>
      <div className="button-container">
        <Button variant="text" onClick={onPrevious}>
          {t("label.previous")}
        </Button>
        <Button
          type="submit"
          color="primary"
          disabled={!selected}
          variant="contained"
          onClick={() => {
            if (selected) onNext(selected);
          }}
        >
          {t("label.next")}
        </Button>
      </div>
    </Styles>
  );
}

const Styles = styled(Pane)`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(3)};

  .list-item {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    gap: ${({ theme }) => theme.spacing(2)};
    height: 75px;
    width: 100%;
    padding: 0 17px;

    border-radius: 4px;
    background-color: #f1f1f1;
    color: #000000;
    font-weight: 500;

    > .MuiSvgIcon-root {
      fill: #000000;
    }

    &.active {
      background-color: #3fabff;
      color: white;

      .MuiSvgIcon-root {
        fill: white;
      }
    }
  }

  .button-container {
    width: 100%;
    display: flex;
    flex-direction: row;
    gap: ${({ theme }) => theme.spacing(1)};
    justify-content: flex-end;
  }
`;
